import { BodyCell, DataGrid } from '@tableau/data-grid-3-wrapper';
import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { ConnectionDetailInfo, isRemote } from '../../../ts/models/ConnectionDetailInfo';
import { IDataConnectionInfo } from '../../../ts/models/IDataConnectionInfo';
import { DataConnections } from '../../../ts/resources/DataConnections';
import { DataGridCells } from './DataGridCells';
import { StyledCellFormatter } from './StyledCellWrapper';

// These are (mostly) a direct copy of common/DataGridCells
// Here they just use the classes from data-grid-3-wrapper

export namespace DataConnectionDataGridCells {
  export function AuthenticationCellFormatter(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      (props: BodyCell.Props): React.ReactElement<any> => {
        const connection = props.row.data as IDataConnectionInfo;
        const text = DataConnections.getDisplayAuthentication(connection);

        // Tableau server connections return empty string
        return React.createElement('span', {}, text);
      }
    );
  }

  export function UsernameCellFormatter(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      (props: BodyCell.Props): React.ReactElement<any> => {
        const connection = props.row.data as IDataConnectionInfo;
        const text = DataConnections.getDisplayUsername(connection);

        // File, Tableau Server, and Web Data connections return empty string
        return React.createElement('span', {}, text);
      }
    );
  }
}
